import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ClienteCentralCompraParticipante } from '../cliente-central-compra-participante';

@Component({
    selector: 'sgt-cliente-central-compra-participante-select',
    templateUrl: './cliente-central-compra-participante-select.component.html',
    styleUrls: ['./cliente-central-compra-participante-select.component.less']
})
export class ClienteCentralCompraParticipanteSelectComponent {
    /* Participantes da central de compras **/
    @Input() participantes: ClienteCentralCompraParticipante[];
    /** Evento emitido ao selecionar o participante da central de compras */
    @Output() onSelectParticipante = new EventEmitter<ClienteCentralCompraParticipante>();


    /** Ao selecionar um participante da central de compras */
    selectParticipante(participante: ClienteCentralCompraParticipante) {
        this.onSelectParticipante.emit(participante);
    }
}
